import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import bulletin from './bulletin/reducer';
import connection from './connection/reducer';
import { error } from './error/reducer';
import { dateRange } from './date/reducer';
import style from './style/reducer';
import type from './type/reducer';

const createRootReducer = history =>
  combineReducers({
    bulletin,
    connection,
    error,
    dateRange,
    router: connectRouter(history),
    style,
    type,
  });

export default createRootReducer;
